/*
 *
 * PracticePage actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_PRACTICES_ACTION,
  SELECT_PRACTICE_ACTION,
} from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getPracticesAction(callback = () => {}) {
  return {
    type: GET_PRACTICES_ACTION,
    callback,
  };
}

export function selectPracticeAction(practice) {
  return {
    type: SELECT_PRACTICE_ACTION,
    practice,
  };
}
